import { Link } from 'react-router-dom';
import Navbar from '../../home/components/Navbar';
import Footer from '../../home/components/Footer';
import Contact from '../../home/components/Contact';
import WhatsAppDiagnostic from '../../home/components/WhatsAppDiagnostic';

export default function PrixReparationFenetreLyon2025() {
  const priceTable = [
    { service: 'Remplacement poignée', price: '45€ - 80€', duration: '30 min' },
    { service: 'Réparation crémone', price: '80€ - 150€', duration: '1h' },
    { service: 'Ajustement ouvrant', price: '60€ - 100€', duration: '45 min' },
    { service: 'Remplacement joints', price: '40€ - 90€', duration: '1h' },
    { service: 'Remplacement vitrage simple', price: '150€ - 300€', duration: '2h' },
    { service: 'Remplacement double vitrage', price: '250€ - 500€', duration: '3h' },
    { service: 'Réparation baie vitrée', price: '180€ - 600€', duration: '3-4h' },
    { service: 'Rénovation complète fenêtre', price: '300€ - 800€', duration: '1 jour' }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-emerald-600 via-teal-500 to-cyan-500 pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
        <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
          <div className="max-w-3xl">
            <div className="inline-flex items-center space-x-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
              <i className="ri-price-tag-3-line text-white"></i>
              <span className="text-white text-sm font-medium">Tarifs 2025 Actualisés</span>
            </div>
            
            <h1 className="text-5xl lg:text-6xl font-extrabold text-white mb-6 leading-tight">
              Prix Réparation Fenêtre Lyon 2025
            </h1>
            
            <p className="text-xl text-white/90 mb-8 leading-relaxed">
              Guide complet des tarifs de réparation de fenêtres à Lyon en 2025. Prix détaillés, facteurs de coût et conseils pour optimiser votre budget.
            </p>
          </div>
        </div>
      </section>

      {/* Price Table */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-5xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-extrabold text-gray-900 mb-4">
              Grille Tarifaire 2025
            </h2>
            <p className="text-gray-600 text-lg">
              Prix moyens constatés à Lyon et sa région
            </p>
          </div>

          <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-gradient-to-r from-emerald-600 to-teal-500">
                  <tr>
                    <th className="px-6 py-4 text-left text-sm font-bold text-white">Prestation</th>
                    <th className="px-6 py-4 text-left text-sm font-bold text-white">Prix TTC</th>
                    <th className="px-6 py-4 text-left text-sm font-bold text-white">Durée</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {priceTable.map((item, index) => (
                    <tr key={index} className="hover:bg-gray-50 transition-colors">
                      <td className="px-6 py-4 text-sm font-medium text-gray-900">{item.service}</td>
                      <td className="px-6 py-4 text-sm text-emerald-600 font-bold">{item.price}</td>
                      <td className="px-6 py-4 text-sm text-gray-600">{item.duration}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div className="mt-6 bg-emerald-50 rounded-xl p-6">
            <p className="text-sm text-gray-700 flex items-start">
              <i className="ri-information-line text-emerald-600 text-lg mr-2 mt-0.5"></i>
              <span>Prix indicatifs incluant main d'œuvre et déplacement dans la Métropole de Lyon. Devis gratuit et personnalisé sur demande.</span>
            </p>
          </div>
        </div>
      </section>

      {/* Article Content */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <article className="prose prose-lg max-w-none">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">
              Prix Réparation Fenêtre Lyon : Guide Complet 2025
            </h2>
            
            <p className="text-gray-700 leading-relaxed mb-6">
              Vous cherchez à connaître le prix d'une réparation de fenêtre à Lyon ? Ce guide détaillé vous présente tous les tarifs pratiqués en 2025, les facteurs qui influencent le coût et nos conseils pour optimiser votre budget.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Facteurs Influençant le Prix
            </h3>
            
            <ul className="space-y-3 mb-6">
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-emerald-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Type de matériau :</strong> PVC (moins cher), aluminium (moyen), bois (plus cher)</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-emerald-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Dimensions :</strong> Plus la fenêtre est grande, plus le coût augmente</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-emerald-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Type de vitrage :</strong> Simple, double ou triple vitrage</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-emerald-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Complexité :</strong> Accessibilité, étage, contraintes techniques</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-emerald-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Urgence :</strong> Intervention rapide peut entraîner un surcoût</span>
              </li>
            </ul>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Prix par Type de Réparation
            </h3>
            
            <h4 className="text-xl font-bold text-gray-900 mb-3 mt-6">
              Réparation de Quincaillerie (45€ - 150€)
            </h4>
            
            <p className="text-gray-700 leading-relaxed mb-4">
              Le remplacement de quincaillerie est l'intervention la plus courante et la plus économique. Une poignée coûte entre 45€ et 80€, une crémone entre 80€ et 150€. Ces prix incluent la pièce et la main d'œuvre.
            </p>

            <h4 className="text-xl font-bold text-gray-900 mb-3 mt-6">
              Remplacement de Vitrage (150€ - 500€)
            </h4>
            
            <p className="text-gray-700 leading-relaxed mb-4">
              Le remplacement de vitrage varie selon le type : simple vitrage (150€-300€), double vitrage standard (250€-400€), double vitrage renforcé (300€-500€). Pour une baie vitrée, comptez 400€ à 1000€ selon les dimensions.
            </p>

            <h4 className="text-xl font-bold text-gray-900 mb-3 mt-6">
              Rénovation Complète (300€ - 800€)
            </h4>
            
            <p className="text-gray-700 leading-relaxed mb-4">
              Une rénovation complète comprend le remplacement du vitrage, de la quincaillerie, des joints et l'ajustement des ouvrants. Prix moyen : 400€ à 600€ pour une fenêtre standard PVC, 500€ à 800€ pour l'aluminium.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Comparatif Prix par Matériau
            </h3>
            
            <ul className="space-y-3 mb-6">
              <li className="flex items-start">
                <i className="ri-arrow-right-s-line text-emerald-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Fenêtre PVC :</strong> Réparation 60€-400€, remplacement complet 300€-800€</span>
              </li>
              <li className="flex items-start">
                <i className="ri-arrow-right-s-line text-emerald-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Fenêtre Aluminium :</strong> Réparation 80€-500€, remplacement complet 500€-1200€</span>
              </li>
              <li className="flex items-start">
                <i className="ri-arrow-right-s-line text-emerald-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Fenêtre Bois :</strong> Réparation 100€-600€, rénovation complète 400€-1000€</span>
              </li>
            </ul>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Conseils pour Optimiser votre Budget
            </h3>
            
            <ul className="space-y-3 mb-6">
              <li className="flex items-start">
                <i className="ri-lightbulb-line text-emerald-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Demandez plusieurs devis :</strong> Comparez au moins 3 professionnels à Lyon</span>
              </li>
              <li className="flex items-start">
                <i className="ri-lightbulb-line text-emerald-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Privilégiez la réparation :</strong> Souvent plus économique que le remplacement</span>
              </li>
              <li className="flex items-start">
                <i className="ri-lightbulb-line text-emerald-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Groupez les interventions :</strong> Réparer plusieurs fenêtres en une fois réduit le coût</span>
              </li>
              <li className="flex items-start">
                <i className="ri-lightbulb-line text-emerald-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Vérifiez les garanties :</strong> Certaines réparations peuvent être couvertes</span>
              </li>
              <li className="flex items-start">
                <i className="ri-lightbulb-line text-emerald-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Profitez des aides :</strong> MaPrimeRénov' pour les travaux d'isolation</span>
              </li>
            </ul>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Prix Spécifiques à Lyon
            </h3>
            
            <p className="text-gray-700 leading-relaxed mb-6">
              À Lyon, les tarifs sont légèrement supérieurs à la moyenne nationale (+10-15%) en raison du coût de la vie et des contraintes urbaines. Les interventions en centre-ville (Presqu'île, Vieux-Lyon) peuvent nécessiter des autorisations spéciales et donc augmenter le coût. Les frais de déplacement sont généralement inclus dans la Métropole de Lyon.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Conclusion
            </h3>
            
            <p className="text-gray-700 leading-relaxed mb-6">
              Le prix d'une réparation de fenêtre à Lyon varie de 45€ pour une simple poignée à 800€ pour une rénovation complète. Dans 80% des cas, la réparation est plus économique que le remplacement. N'hésitez pas à demander un devis gratuit pour obtenir un prix précis adapté à votre situation.
            </p>
          </article>
        </div>
      </section>

      {/* WhatsApp Diagnostic */}
      <WhatsAppDiagnostic />

      {/* Contact */}
      <Contact />
      
      <Footer />
    </div>
  );
}
